//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../no/Builder.js";
let d=[[[0,"ConstraintType",1,0],[0,"DoubleValue",1,0],[0,"IntValue",1,0],[0,"StringValue",1,0]],[],[]];
SPLM.Join.SubtypeAuthorValidValuesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.SubtypeAuthorValidValuesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Join.SubtypeAuthorValidValuesBuilder.ConstraintTypes = Object.freeze({
    "Equals" : "Equals", "Min" : "Min", "Max" : "Max", "MinInclusive" : "MinInclusive", "MaxInclusive" : "MaxInclusive", "NotEquals" : "NotEquals", "Contains" : "Contains", "DoesNotContain" : "DoesNotContain", "BeginsWith" : "BeginsWith", "EndsWith" : "EndsWith"});

export default SPLM;